import React, {Component} from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import {getDefaultExposure, preparePlayersExposure} from 'helpers/player-helper';
import Action from 'actions';
import Const from 'constants';

class GeneralExposure extends Component {
    constructor(props) {
        super(props);
        const {propName} = this.props;
        this.isValueBeingChanged = false;
        this.settingsSignature = null;
        this.state = {value: getDefaultExposure(propName)};
    }

    componentDidUpdate() {
        const {resetSettings, propName} = this.props;
        if (resetSettings.getSignature() !== this.settingsSignature) {
            this.settingsSignature = resetSettings.getSignature();
            this.setState({value: getDefaultExposure(propName)});
        }
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(value) {
        const {players, propName, modes = [Const.DEFAULT_MODE]} = this.props;

        const correctValue = NumberHelper.prepareInt(value, getDefaultExposure(propName))
            .limitByRange(getDefaultExposure('min'), getDefaultExposure('max'), getDefaultExposure(propName))
            .get();

        this.onChange(correctValue);

        this.isValueBeingChanged = false;

        let exposure = [];
        modes.map((mode) => {
            const modeExposure = preparePlayersExposure(players, propName, correctValue, mode);

            exposure = [...exposure, ...modeExposure];
        });

        this.props.dispatch(Action.set('PlayersExposure', exposure));
    }

    render() {
        const {className} = this.props;

        return (
            <input
                className={className}
                value={`${this.state.value}`}
                onChange={(e) => ::this.onChange(e.target.value)}
                onBlur={(e) => ::this.onBlur(e.target.value)}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {reset} = state;
    return {
        resetSettings: reset.settings,
    };
}

export default connect(mapStatesToProps)(GeneralExposure);
